import { render, staticRenderFns } from "./CDASelecionadasProtesto.vue?vue&type=template&id=da3b4f2c&"
import script from "./CDASelecionadasProtesto.vue?vue&type=script&lang=js&"
export * from "./CDASelecionadasProtesto.vue?vue&type=script&lang=js&"
import style0 from "./CDASelecionadasProtesto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports